firebird.factory('videoFilterService', [
    '$window',
    '$rootScope',
    '$timeout',
    '$interval',
    'logService',
    'helperService',
    'storageService',
    'configService',
    'localizationService',
    'executionEnvironmentEnum',
    function (
        $window,
        $rootScope,
        $timeout,
        $interval,
        logService,
        helperService,
        storageService,
        configService,
        localizationService,
        executionEnvironmentEnum
    ) {
        const logger = new LogServiceWrapper(logService, 'videoFilterService');

        var service = {
            initialize: initialize,
            initVideoFilter: initVideoFilter,
            resetVideoFilter: resetVideoFilter,
            startVideoFilterStream: startVideoFilterStream,
            stopVideoFilterStream: stopVideoFilterStream,
            onStartVideoFilterComplete: onStartVideoFilterComplete,
            videoFilterCheckStatsSend: videoFilterCheckStatsSend,
            onStartVirtualBackgroundStream: onStartVirtualBackgroundStream,
            onStopVirtualBackgroundStream: onStopVirtualBackgroundStream,
            promptToDisableVideoBackground: promptToDisableVideoBackground,
            setIsVideoFiltersAvailable: setIsVideoFiltersAvailable,
            getIsVideoFiltersAvailable: getIsVideoFiltersAvailable,
            setActiveFeedStream: setActiveFeedStream,
            getActiveFeedStream: getActiveFeedStream,
            setVideoFilterConfig: setVideoFilterConfig,
            getVideoFilterConfig: getVideoFilterConfig
        };

        var msgflow = null; // will be set by videoroomCtrl, but not others.
        var showAlert = function () {}; // no-op function. will be set by videoroomCtrl, but not others.
        var isVideoFiltersAvailable = true; // set to false in webinars if userpair isn't true.
        var activeFeedStream = null;
        var videoFilterConfig = 'inline'; // set from firebirdCtrl based on user pair.

        var videoFilterConfigAllowedValues = ['inline', 'origmodel', 'auto', 'alt', 'auto-alt'];

        var requireWasSet = false; // whether require = nodeRequire was done here, so that it can be reverted.
        // URL param can modify some config, e.g., ?videoFilter=%7B"width":1280,"height":720,"frameRate":30%7D

        var fixVideoFilterForSimulcast2 = true;

        // if true, use mediapipe instead of previous way. model is changed too.
        var mediapipe = false;

        var videoFilter = {
            value: null,
            model: null, // default or orig or alt
            origWorkerURL: '/lib/videobg/worker.js', // when videoFilterConfig is 'origmodel'
            altWorkerURL: '/lib/videobg/v3/index.js', // used by default or 'altmodel'

            width: 640,
            height: 360,
            captureWidth: 640,
            captureHeight: 360,
            frameRate: 15,
            pixelsWidth: 640,
            pixelsHeight: 360,
            engine: null,
            config: null,
            inline: false,
            extra: null, // additional attributes set via params if needed

            pending: false,
            counter: 0,

            canvasInput: null,
            canvasOutput: null,
            canvasMask: null,
            canvasBg: null,
            videoStream: null,
            interval: null,
            videoInput: null,
            canvasStream: null,
            background: null,

            objectFit: 'cover', // "cover", "contain" or "stretch"

            initialized: false,
            averageTime: 50, // how much time on average it takes to run the tensorflow algorithm. initialize to something reasonable.
            pipeline: 1, // how many outstanding request to one worker
            worker: null,
            workers: 2,
            windex: -1, // {thread: null, pending: 0, lastDone: 0, startTime: 0}
            workerEngine: null, // which engine worker is actually started with?
            promptOnLowFrameRate: false, // enable this if we need to prompt on low framerate when the feature is enabled.
            minTime: 0 // ms; do not perform tensor flow operation for N ms after last done
        };

        // whether and how to stop video filter if framerate or CPU usage suffer, or to switch to higher accuracy.
        var videoFilterMonitor = {
            frameRates: [],
            maxCount: 2,
            threshold: 0.5, // fraction
            count: 100,
            alt: 30,
            normal: 60,
            stop: 200, // various threshold values. count determines how often to make decisions. alt, normal, stop determine threshold ms.
            lastPrompt: false, // whether prompting, or last time.
            promptInterval: 120000 // 2min. minimum interval between prompts in ms.
        };

        var previewVideoFilter = {}; // index id, value object with a subset of attributes.
        var previewVideoStream = {};

        Object.assign(service, {
            // add these for dev/debugging from JS console.
            videoFilter: videoFilter,
            videoFilterMonitor: videoFilterMonitor,
            previewVideoFilter: previewVideoFilter,
            previewVideoStream: previewVideoStream
        });

        return service;

        function initialize(msgflowParam, showAlertParam) {
            if (msgflowParam) {
                msgflow = msgflowParam;
            }
            if (showAlertParam) {
                showAlert = showAlertParam;
            }
        }

        function getVideoFilter(firsttime) {
            // // temporarily move the feature behind user pair (which is set even with URL param in firebirdCtrl).
            // if (!(configService.getSfuPayload()).videoFilter) {
            //     return null;
            // }
            var value = storageService.get('videoFilter');

            if (!value) {
                // no filter configured in settings.
                return null;
            }

            if (firsttime && value.startsWith('change-bg:blob:')) {
                // workaround for video blob from last load, no longer valid.
                storageService.remove('videoFilter');
                return null;
            }

            // get configs if any, in order, URL param, storage from settings, user pair.
            var data =
                helperService.getQueryParameter('videoFilter') ||
                JSON.parse(storageService.get('advancedSettings') || '{}').videoFilter ||
                null;
            // if disabled in config. default is enabled.
            if (data && data == 'false') {
                return null;
            }
            // data is null, 'true', or some other JSON encoded string.
            if (data && data != 'true') {
                try {
                    data = JSON.parse(data);
                    data.value = value; // add filter value to other configs object.
                } catch (e) {
                    logger.warn('getVideoFilter', 'failed to parse videoFilter config', data, e);
                    data = { value: value }; // ignore error, assume true
                }
            } else {
                data = { value: value }; // no other config needed
            }

            onVideoFilter(data);

            return data;
        }

        function onVideoFilter(data) {
            // update configs
            for (var attr in data) {
                if (typeof videoFilter[attr] === 'number' || attr == 'objectFit') {
                    videoFilter[attr] = data[attr];
                }
            }
            videoFilter.engine = data.engine || null;
            videoFilter.config =
                helperService.getQueryParameter('videoFilterConfig') ||
                JSON.parse(storageService.get('advancedSettings') || '{}').videoFilterConfig ||
                videoFilterConfig;
            if (videoFilter.config == 'auto') {
                videoFilter.promptOnLowFrameRate = true;
            }
            if (videoFilter.config == 'origmodel' || videoFilter.config == 'auto' || videoFilter.config == 'alt') {
                // variations of orig model
                videoFilter.model = 'orig';
            }
            if (videoFilter.engine == 'wasm') {
                // our new model does not work with web assembly yet, even on latest tfjs.
                videoFilter.model = 'orig';
            }

            // if inline is enabled (only for new/default model), then load worker as script tag. Not allowed for orig model.
            videoFilter.inline = videoFilter.model != 'orig' && videoFilter.config == 'inline';

            if (videoFilter.workers < 0) {
                videoFilter.workers = 0;
            }

            var extra =
                helperService.getQueryParameter('videoFilterExtra') ||
                JSON.parse(storageService.get('advancedSettings') || '{}').videoFilterExtra ||
                null;
            if (extra) {
                videoFilter.extra = {};
                extra.split(',').forEach(function (nv) {
                    var index = nv.indexOf(':');
                    var name = index >= 0 ? nv.substring(0, index) : nv;
                    var value = index >= 0 ? nv.substring(index + 1) : '';
                    videoFilter.extra[name] = value;
                });
            } else {
                videoFilter.extra = null;
            }
        }

        function initVideoFilter() {
            fixVideoFilterForSimulcast2 = configService.getClientValue('fixVideoFilterForSimulcast2') !== 'false';

            // update mediapipe flag, must be called after configService readStorage is done.
            mediapipe = configService.getValue('mediapipe') == 'true';

            var data = getVideoFilter(true);
            if (data && !videoFilter.worker) {
                startVideoFilterWorker();
            }
        }

        function resetVideoFilter() {
            logService.log('resetVideoFilter ...');
            service.stopVideoFilterStream();
            if (videoFilter.worker) {
                stopVideoFilterWorker();
            }
        }

        // prompt the user to stop video filter if too less framerate.
        function videoFilterCheckStatsSend(result) {
            if (videoFilter.value && videoFilter.promptOnLowFrameRate) {
                var list = result
                    .filter(function (item) {
                        return item.media == 'video' && item.dir == 'outbound' && !item.screen;
                    })
                    .map(function (item) {
                        return item.frameRate;
                    });
                if (list.length > 0) {
                    var data = videoFilterMonitor;
                    var frameRate = list[0];
                    if (frameRate == 0) {
                        data.frameRates.shift(); // remove one
                    } else {
                        data.frameRates.push(frameRate);
                        if (data.frameRates.length > data.maxCount) {
                            data.frameRates.splice(0, data.frameRates.length - data.maxCount);
                        }
                    }
                    if (data.frameRates.length == data.maxCount) {
                        var avg =
                            data.frameRates.reduce(function (sum, value) {
                                return sum + value;
                            }, 0) / data.frameRates.length;
                        var threshold = Math.round(videoFilter.frameRate * data.threshold);
                        if (avg < threshold) {
                            logService.log(
                                'videoFilterService - videoFilter low framerate detected ' +
                                    avg +
                                    'fps < threshold ' +
                                    threshold
                            );
                            promptToDisableVideoBackground();
                        }
                    }
                }
            }
        }

        // prompt the user to stop video filter if too less framerate.
        function promptToDisableVideoBackground() {
            var data = videoFilterMonitor;
            if (
                data.lastPrompt === false ||
                (typeof data.lastPrompt === 'number' && Date.now() >= data.lastPrompt + data.promptInterval)
            ) {
                data.lastPrompt = true;
                var title = localizationService.translate(
                    'HEADER.SETTINGS.VIRTUAL_BACKGROUND.VIDEO_QUALITY_ALERT.VIDEO_QUALITY_TITLE'
                );
                var text = localizationService.translate(
                    'HEADER.SETTINGS.VIRTUAL_BACKGROUND.VIDEO_QUALITY_ALERT.VIDEO_QUALITY_TEXT'
                );

                var override = {
                    okText: localizationService.translate(
                        'HEADER.SETTINGS.VIRTUAL_BACKGROUND.VIDEO_QUALITY_ALERT.VIDEO_QUALITY_OK_TEXT'
                    ),
                    cancelText: localizationService.translate(
                        'HEADER.SETTINGS.VIRTUAL_BACKGROUND.VIDEO_QUALITY_ALERT.VIDEO_QUALITY_CANCEL_TEXT'
                    )
                };

                showAlert(
                    title,
                    text,
                    false,
                    function (confirmed) {
                        if (confirmed) {
                            data.lastPrompt = false;
                            logService.log('videoFilterService - videoFilter stopping on confirmation');
                            var previous = storageService.get('videoFilter');
                            if (previous) {
                                storageService.remove('videoFilter');
                                $rootScope.$broadcast('video-filter-changed', {
                                    oldValue: previous,
                                    newValue: null
                                });
                            }
                        } else {
                            data.lastPrompt = Date.now();
                            logService.log(
                                'videoFilterService videoFilter not stopping feature. will not prompt again for 2minutes. now=' +
                                    data.lastPrompt
                            );
                        }
                    },
                    override
                );
            }
        }

        // start a worker thread to run video filter
        function startVideoFilterWorker() {
            var existing = videoFilter.workerEngine;
            videoFilter.workerEngine = videoFilter.engine || 'webgl';

            if (existing && existing != videoFilter.workerEngine) {
                // engine changed, stop previous worker.
                videoFilter.initialized = false;
                $window.$('#videoroom-videos').attr('videobg', 'loading');
                $rootScope.$broadcast('virtual-background-initialized', false);

                stopVideoFilterWorker();
            }

            videoFilter.worker = [];

            var params = videoFilter.engine ? '?engine=' + videoFilter.engine : '';
            if (videoFilter.extra) {
                // append extra to params.
                var extra = Object.entries(videoFilter.extra)
                    .map(function (kv) {
                        return encodeURIComponent(kv[0]) + '=' + encodeURIComponent(kv[1]);
                    })
                    .join('&');
                if (extra) {
                    params = params + (params ? '&' : '?') + extra;
                }
            }

            if (!videoFilter.inline) {
                var workerURL = videoFilter.model != 'orig' ? videoFilter.altWorkerURL : videoFilter.origWorkerURL;

                for (var i = 0; i < (videoFilter.workers || 1); ++i) {
                    videoFilter.worker.push({ thread: null, pending: false, startTime: 0, lastDone: 0, index: i });
                }
                videoFilter.worker.forEach(function (worker) {
                    worker.thread = new Worker(workerURL + params);

                    worker.thread.addEventListener('message', function (event) {
                        processVideoFilterResult(event.data, worker);
                    });
                });
            } else {
                if (!$window.$('head > script#videoFilterWorker').length) {
                    // avoid double include of script.
                    var workerInline = videoFilter.altWorkerURL; // orig model is not allowed/supported.

                    if (mediapipe) {
                        // mediapipe related code won't work with worker; but only with inline function call.
                        workerInline += (workerInline.indexOf('?') > 0 ? '&' : '?') + 'mediapipe=true';
                    }

                    logService.log('videoFilterService loading worker script');

                    // This does not work. so use without jQuery.
                    // $window.$('head').append($window.$('<script id="#videoFilterWorker" type="text/javascript" src="' + workerURL + '"></script>'));

                    if (helperService.isElectron() && $window.nodeRequire !== undefined) {
                        requireWasSet = true;
                        $window.require = $window.nodeRequire;
                    }
                    var script = document.createElement('script');
                    script.id = 'videoFilterWorker'; // this is used to avoid double include of script.
                    script.setAttribute('type', 'text/javascript');
                    script.addEventListener('load', function (event) {
                        logService.log('videoFilterService loaded worker script');
                    });
                    script.setAttribute('src', workerInline);
                    document.head.appendChild(script);
                }
            }
        }

        function processVideoFilterResult(data, worker) {
            if (!data || data.type != 'response') {
                return;
            }

            var filter = data.state ? previewVideoFilter[data.state] : videoFilter;
            if (!mediapipe) {
                var pixels = new ImageData(new Uint8ClampedArray(data.pixels), data.width, data.height);
                if (filter) {
                    var ctx = filter.canvasMask.getContext('2d');
                    ctx.putImageData(pixels, 0, 0);
                }
            } else {
                // pixels data is already an image.
                if (filter) {
                    var ctx1 = filter.canvasMask.getContext('2d');
                    ctx1.save();
                    ctx1.clearRect(0, 0, data.width, data.height);
                    ctx1.drawImage(data.pixels, 0, 0, data.width, data.height);
                    ctx1.globalCompositeOperation = 'source-out';
                    ctx1.fillStyle = '#FFFFFF';
                    ctx1.fillRect(0, 0, data.width, data.height);
                    ctx1.restore();
                }
            }
            if (worker) {
                worker.pending = Math.max(0, worker.pending - 1); // cap min at 0
                worker.lastDone = Date.now();
            }
            if (data.time && data.time < 400) {
                var f = 0.1; // filter to average out. ignore too high values >= 400
                videoFilter.averageTime = data.time * f + videoFilter.averageTime * (1 - f);
            }
            if (worker) {
                // do not use logService.log or console.log here due to high frequency.
                worker.counter = (worker.counter || 0) + 1;
                if (worker.counter % 32 == 0) {
                    // do not use logService for high frequency log. print every 32.
                    console.info('tf-time(' + worker.index + ')=' + Math.round(videoFilter.averageTime));
                }
                var monitor = videoFilterMonitor;
                if (worker.counter < 0 || worker.counter % monitor.count == 0) {
                    // review if avg time is good or not?
                    if (
                        (videoFilter.config == 'auto' || videoFilter.config == 'auto-alt') &&
                        videoFilter.averageTime > monitor.stop
                    ) {
                        // prompt to stop.
                        logService.log(
                            'videoFilterService - videobg - stopping the feature, time=' + videoFilter.averageTime
                        );
                        promptToDisableVideoBackground();
                    } else if (videoFilter.config == 'auto' && videoFilter.averageTime <= monitor.alt) {
                        // switch to alt
                        logService.log(
                            'videoFilterService - videobg - switching to alt config, time=' + videoFilter.averageTime
                        );
                        videoFilter.config = 'auto-alt'; // sent request to worker will use this.
                    } else if (videoFilter.config == 'auto-alt' && videoFilter.averageTime > monitor.normal) {
                        // switch to default
                        videoFilter.config = 'auto'; // sent request to worker will use this.
                        logService.log(
                            'videoFilterService - videobg - switching to default config, time=' +
                                videoFilter.averageTime
                        );
                    }
                }
            }

            if (!videoFilter.initialized) {
                videoFilter.initialized = true;
                $window.$('#videoroom-videos').removeAttr('videobg');
                $rootScope.$broadcast('virtual-background-initialized', true);
            }
        }

        function stopVideoFilterWorker() {
            if (videoFilter.worker) {
                videoFilter.worker.forEach(function (worker) {
                    worker.thread.terminate();
                    worker.thread = null;
                });
                videoFilter.worker = null;
            }
            if (videoFilter.inline) {
                // remove the script tag for inline worker code.
                if ($window.$('head > script#videoFilterWorker').length) {
                    $window.videoFilterWorker = null;
                    $window.$('head > script#videoFilterWorker').remove();
                }
            }
        }

        // create a video stream from canvas if video filter enabled, or return undefined.
        function startVideoFilterStream(
            getMediaConstraints,
            filterData,
            identifier,
            completeCallback,
            customizeStreamCallback
        ) {
            if (helperService.getVDIRef().getVdiType() === executionEnvironmentEnum.Citrix) {
                //Avoid filter processing of video stream on VDI
                return undefined;
            }
            if (!service.getIsVideoFiltersAvailable()) {
                return undefined;
            }

            if (identifier) {
                filterData = previewVideoFilter[identifier];
            }
            var previous = identifier ? 'none' : videoFilter.value; // previous value is lost for preview
            if (!filterData) {
                filterData = getVideoFilter(false);
            } else {
                onVideoFilter(filterData);
            }
            var filter = identifier ? filterData : videoFilter;

            if (!filterData) {
                // not enabled.
                return undefined;
            }

            var value = filterData.value;
            logService.log(
                'videoFilterService startVideoFilterStream ' +
                    (previous || '').substr(0, 20) +
                    ' => ' +
                    (value || '').substr(0, 20) +
                    (identifier ? ' identifier=' + identifier : '')
            );
            if (previous != value) {
                if (previous && previous.startsWith('change-bg:')) {
                    filter.background = null;
                }
                if (value && value.startsWith('change-bg:')) {
                    if (!value.startsWith('change-bg:blob:')) {
                        var image = (filter.background = new Image());
                        image.src = value.substr(10);
                    } else {
                        var video = (filter.background = $window.document.createElement('video'));
                        video.autoplay = true;
                        video.muted = true;
                        video.loop = true;
                        video.src = value.substr(10);
                        video.play();
                    }
                }

                filter.value = value;
            }
            if (value && !videoFilter.worker) {
                startVideoFilterWorker();
            }

            if (msgflow && !identifier) {
                msgflow.event('video filter', { value: (value || '').substr(0, 20) });
            }

            if (!filter.canvasStream) {
                videoFilter.initialized = false;

                if (identifier !== 'header') {
                    $window.$('#videoroom-videos').attr('videobg', 'loading');
                }

                $rootScope.$broadcast('virtual-background-initialized', false);

                var canvasInput = (filter.canvasInput = $window.document.createElement('canvas'));
                canvasInput.width = videoFilter.pixelsWidth;
                canvasInput.height = videoFilter.pixelsHeight;

                var canvasMask = (filter.canvasMask = $window.document.createElement('canvas'));
                canvasMask.width = videoFilter.pixelsWidth;
                canvasMask.height = videoFilter.pixelsHeight;

                var canvasBg = (filter.canvasBg = $window.document.createElement('canvas'));
                canvasBg.width = videoFilter.width;
                canvasBg.height = videoFilter.height;

                // full mask initially
                var imageData = canvasMask
                    .getContext('2d')
                    .createImageData(videoFilter.pixelsWidth, videoFilter.pixelsHeight);
                new Uint32Array(imageData.data.buffer).fill(0xffffffff);
                canvasMask.getContext('2d').putImageData(imageData, 0, 0);

                var canvasOutput = (filter.canvasOutput = $window.document.createElement('canvas'));
                var videoInput = (filter.videoInput = $window.document.createElement('video'));
                videoInput.width = canvasOutput.width = videoFilter.width;
                videoInput.height = canvasOutput.height = videoFilter.height;
                videoInput.setAttribute('autoplay', true);
                videoInput.setAttribute('muted', true);

                filter.canvasStream = canvasOutput.captureStream();

                var media = getMediaConstraints('video-filter'); // will include deviceId if needed.
                if (media && media.video) {
                    media.video.frameRate = Math.min(media.video.frameRate || 30, videoFilter.frameRate);
                    if (!helperService.isMac()) {
                        // delay applying lower constraints for Mac OSX
                        var captureWidth = fixVideoFilterForSimulcast2 ? videoFilter.captureWidth : videoFilter.width;
                        var captureHeight = fixVideoFilterForSimulcast2
                            ? videoFilter.captureHeight
                            : videoFilter.height;
                        media.video.width = Math.min(media.video.width || 1280, captureWidth);
                        media.video.height = Math.min(media.video.height || 720, captureHeight);
                    }
                    if (filter.deviceId) {
                        media.video.deviceId = getConstraintDeviceId(filter.deviceId);
                        console.log(media);
                    }
                }

                var timer = $timeout(function () {
                    logService.log('videoFilterService - startVideoFilterStream took longer than 10s');
                    timer = null;
                    if (completeCallback) {
                        completeCallback(identifier, 'timed out');
                    }
                    if (customizeStreamCallback) {
                        customizeStreamCallback('timed out');
                    }
                }, 10000);

                $window.navigator.mediaDevices
                    .getUserMedia(media)
                    .then(function (stream) {
                        if (!timer) {
                            stream.getTracks().forEach(function (track) {
                                track.stop();
                            });
                            //called only for preview (identifier supplied).
                            if (identifier) {
                                service.stopVideoFilterStream(identifier);
                            }
                            return;
                        }

                        filter.videoStream = stream;
                        filter.videoInput.srcObject = stream;

                        $timeout.cancel(timer);
                        timer = null;
                        var videoTrack = stream.getVideoTracks()[0];

                        if (helperService.isMac()) {
                            // avoid zoom, by creating a clone and deleting afterwards, while lower constraints are applied.
                            var track1 = videoTrack.clone();
                            $timeout(function () {
                                track1.stop();
                            }, 2000);

                            var captureWidth = fixVideoFilterForSimulcast2
                                ? videoFilter.captureWidth
                                : videoFilter.width;
                            var captureHeight = fixVideoFilterForSimulcast2
                                ? videoFilter.captureHeight
                                : videoFilter.height;
                            var constraints = Object.assign({}, videoTrack.getConstraints(), {
                                width: Math.min(media.video.width || 1280, captureWidth),
                                height: Math.min(media.video.height || 720, captureHeight)
                            });
                            videoTrack.applyConstraints(constraints).catch(function (error) {
                                logger.error(
                                    'startVideoFilterStream',
                                    'failed to apply videoFilter constraints',
                                    constraints,
                                    error
                                );
                            });
                        }

                        videoTrack.contentHint = 'motion';
                        videoTrack.addEventListener('ended', function (event) {
                            logService.log('filterstream input stream track ended unexpectedly');
                            $rootScope.$broadcast('active-track-ended', videoTrack);
                        });

                        if (completeCallback) {
                            completeCallback(identifier);
                        }
                        if (customizeStreamCallback) {
                            customizeStreamCallback('success', stream);
                        }
                    })
                    .catch(function (err) {
                        logger.error('startVideoFilterStream', 'failed to get user media', err);
                        $timeout.cancel(timer);
                        timer = null;

                        if (filter && filter.videoStream) {
                            try {
                                filter.videoStream.getTracks().forEach(function (track) {
                                    track.stop();
                                });
                            } catch (e) {
                                logger.error('startVideoFilterStream', 'Error stopping filter.videoStream tracks', e);
                            }
                        }
                        filter.videoStream = null;

                        // var callback = function() {
                        //     if (filter.videoInput && filter.videoInput.videoWidth && filter.videoInput.videoHeight) {
                        //         applyVideoFilter(filter, identifier);
                        //     }
                        //     $window.requestAnimationFrame(callback);
                        // };
                        // $window.requestAnimationFrame(callback);
                        if (completeCallback) {
                            completeCallback(identifier, err);
                        }
                        if (customizeStreamCallback) {
                            customizeStreamCallback('permission error');
                        }
                    });

                var frameRate = (media && media.video && media.video.frameRate) || videoFilter.frameRate;

                filter.interval = $interval(function () {
                    if (filter.videoInput && filter.videoInput.videoWidth && filter.videoInput.videoHeight) {
                        applyVideoFilter(filter, identifier);
                    }
                }, Math.round(1000 / frameRate));
            } else {
                // wrap in timeout because we call this before we return cloned stream
                $timeout(function () {
                    if (customizeStreamCallback) {
                        customizeStreamCallback('stream exists', filter.videoStream);
                    }
                }, 0);
            }

            logService.log('videoFilterService startVideoFilterStream returning');
            // return a clone so that original one is not closed when call is terminated or during reconnection.
            var clonedStream = filter.canvasStream.clone();
            if (!identifier) {
                service.setActiveFeedStream(clonedStream);
            }
            return clonedStream;
        }

        function stopVideoFilterStream(identifier) {
            logService.log('videoFilterService stopVideoFilterStream called');
            var filter = identifier ? previewVideoFilter[identifier] : videoFilter;
            if (!filter) {
                return;
            }
            if (filter.interval) {
                $interval.cancel(filter.interval);
                filter.interval = null;
            }
            if (filter.canvasOutput) {
                filter.canvasOutput = null;
            }
            if (filter.videoInput) {
                filter.videoInput.srcObject = null;
                filter.videoInput = null;
            }
            if (filter.canvasStream) {
                try {
                    filter.canvasStream.getVideoTracks()[0].stop();
                } catch (e) {}
                filter.canvasStream = null;
            }
            if (filter.videoStream) {
                try {
                    filter.videoStream.getVideoTracks()[0].stop();
                } catch (e) {}
                filter.videoStream = null;
            }
            //stopVideoFilterWorker();
            if (!videoFilter.initialized) {
                $window.$('#videoroom-videos').removeAttr('videobg');
            }
            if (videoFilterMonitor) {
                videoFilterMonitor.lastPrompt = false;
                videoFilterMonitor.frameRates = [];
            }
            if (!identifier) {
                service.setActiveFeedStream(null);
            }
        }

        function sendVideoImageToWorker(filter, state) {
            var canvasInput = filter.canvasInput;
            var videoInput = filter.videoInput;

            var width = videoInput.videoWidth;
            var height = videoInput.videoHeight;
            var sizeWidth = videoFilter.pixelsWidth;
            var sizeHeight = videoFilter.pixelsHeight;

            var now = Date.now();

            // wait for minTime after finish of last
            var worker = null;
            var deltaTime =
                videoFilter.averageTime / ((videoFilter.workers || 1) + Math.max(0, videoFilter.pipeline - 1)); // assume 200ms for one run
            if (videoFilter.windex < 0) {
                // pick the first one for first time
                worker = videoFilter.worker[0];
            } else {
                // wait until last one was started more than deltaTime
                var oldest = videoFilter.worker[videoFilter.windex];
                if (now > oldest.startTime + deltaTime) {
                    worker = videoFilter.worker[(videoFilter.windex + 1) % videoFilter.worker.length];
                }
            }

            deltaTime = videoFilter.averageTime / (videoFilter.pipeline || 1);
            // if pipeline is 0, then use old way, otherwise use deltaTime
            if (
                (worker &&
                    worker.thread &&
                    videoFilter.pipeline &&
                    worker.pending < videoFilter.pipeline &&
                    now > worker.startTime + deltaTime) ||
                (!videoFilter.pipeline &&
                    !worker.pending &&
                    (!worker.lastDone || now > worker.lastDone + videoFilter.minTime))
            ) {
                canvasInput.getContext('2d').imageSmoothingEnabled = false;
                canvasInput.getContext('2d').drawImage(videoInput, 0, 0, width, height, 0, 0, sizeWidth, sizeHeight);
                var pixels = canvasInput.getContext('2d').getImageData(0, 0, sizeWidth, sizeHeight);
                videoFilter.windex = worker.index;
                worker.pending++;
                worker.startTime = Date.now();
                var postParam = {
                    type: 'request',
                    pixels: pixels.data.buffer,
                    width: sizeWidth,
                    height: sizeHeight,
                    channels: 4,
                    state: state
                };
                if (videoFilter.config == 'auto-alt' || videoFilter.config == 'alt') {
                    postParam.accuracy = 'high';
                }
                worker.thread.postMessage(postParam, [pixels.data.buffer]);
            }
        }

        function sendVideoImageToInline(filter, state, callback) {
            var canvasInput = filter.canvasInput;
            var videoInput = filter.videoInput;
            var width = videoInput.videoWidth;
            var height = videoInput.videoHeight;
            var sizeWidth = videoFilter.pixelsWidth;
            var sizeHeight = videoFilter.pixelsHeight;

            if ($window.videoFilterWorker) {
                var pixels;
                if (!mediapipe) {
                    canvasInput.getContext('2d').imageSmoothingEnabled = false;
                    canvasInput
                        .getContext('2d')
                        .drawImage(videoInput, 0, 0, width, height, 0, 0, sizeWidth, sizeHeight);
                    var imgdata = canvasInput.getContext('2d').getImageData(0, 0, sizeWidth, sizeHeight);
                    pixels = imgdata.data.buffer;
                } else {
                    // send video element directly.
                    pixels = videoInput;
                }
                var postParam = {
                    type: 'request',
                    pixels: pixels,
                    width: sizeWidth,
                    height: sizeHeight,
                    channels: 4,
                    state: state
                };
                if (videoFilter.config == 'auto-alt' || videoFilter.config == 'alt') {
                    postParam.accuracy = 'high';
                }
                if (mediapipe) {
                    // multiple call does not work.
                    if (videoFilter.pending) {
                        callback(videoInput);
                        return;
                    }
                    videoFilter.pending = true;
                }
                $window.videoFilterWorker(postParam, function (data) {
                    if (mediapipe) {
                        videoFilter.pending = false;
                    }
                    if (data) {
                        if (data.time && data.time < 400) {
                            var f = 0.1; // filter to average out. ignore too high values >= 400
                            videoFilter.averageTime = data.time * f + videoFilter.averageTime * (1 - f);
                        }
                        videoFilter.counter += 1;
                        if (videoFilter.counter % 32 === 0) {
                            console.info('tf-time=' + Math.round(videoFilter.averageTime));
                        }
                        if (requireWasSet && $window.require !== undefined) {
                            requireWasSet = false;
                            delete $window.require;
                        }
                        processVideoFilterResult(data);
                    }
                    // canvas input is not used with media pipe, as video is sent directly to filter function.
                    callback(mediapipe ? videoInput : canvasInput);
                });
            }
        }

        function applyVideoFilter(filter, state) {
            if (videoFilter.worker) {
                //console.log('filter name', filter.name);
                // see https://webrtc.ventures/2019/05/ai-in-webrtc-background-removal-with-tensorflow-in-an-agora-video-chat/
                // and https://github.com/agonza1/OpenVideoCall-Web-Agora/blob/master/src/pages/test/test.js

                filter = filter || videoFilter;

                if (!videoFilter.inline) {
                    sendVideoImageToWorker(filter, state);
                    applyVideoFilterType(filter, state); // do not wait for worker to finish.
                } else {
                    sendVideoImageToInline(filter, state, function (videoInput) {
                        // synchronous callback here. wait for worker, and use that video for subsequent processing.
                        applyVideoFilterType(filter, state, videoInput);
                    });
                }
            }
        }

        function applyVideoFilterType(filter, state, videoInput) {
            if (videoFilter.worker) {
                var canvasOutput = filter.canvasOutput;
                var canvasMask = filter.canvasMask;
                var canvasBg = filter.canvasBg;
                if (!videoInput) {
                    // if supplied, then use that image (may be video or canvas element).
                    videoInput = filter.videoInput;
                }

                if (!canvasOutput || !canvasMask || !canvasBg || !videoInput) {
                    // null checks in case async call makes it invalid.
                    return;
                }

                var ctxBg = canvasBg.getContext('2d');
                var ctxOut = canvasOutput.getContext('2d');
                ctxOut.imageSmoothingEnabled = false;
                ctxBg.imageSmoothingEnabled = false;

                if (filter.value == 'remove-bg') {
                    ctxBg.clearRect(0, 0, videoFilter.width, videoFilter.height);
                    ctxBg.globalCompositeOperation = 'source-over';
                    applyBlurFilter(ctxBg, 2);
                    ctxBg.drawImage(canvasMask, 0, 0, videoFilter.width, videoFilter.height);
                    applyBlurFilter(ctxBg, false);
                    ctxBg.globalCompositeOperation = 'source-out';
                    ctxBg.drawImage(videoInput, 0, 0, videoFilter.width, videoFilter.height); // do not use canvasInput instead of

                    ctxOut.fillStyle = 'white';
                    ctxOut.fillRect(0, 0, videoFilter.width, videoFilter.height);
                    ctxOut.drawImage(canvasBg, 0, 0);

                    // // keep older way to remove bg.
                    // ctxOut.drawImage(videoInput, 0, 0, videoFilter.width, videoFilter.height);
                    // ctxOut.drawImage(canvasMask, 0, 0, videoFilter.width, videoFilter.height);
                } else if (filter.value == 'transparent-bg') {
                    ctxOut.clearRect(0, 0, videoFilter.width, videoFilter.height);
                    ctxOut.globalCompositeOperation = 'source-over';
                    ctxOut.drawImage(videoInput, 0, 0, videoFilter.width, videoFilter.height);
                    ctxOut.globalCompositeOperation = 'destination-out';
                    applyBlurFilter(ctxOut, 3);
                    ctxOut.drawImage(canvasMask, 0, 0, videoFilter.width, videoFilter.height);
                    applyBlurFilter(ctxOut, false);
                } else if (
                    filter.value == 'none' ||
                    (state !== undefined &&
                        !videoFilter.initialized &&
                        filter.value &&
                        (filter.value == 'blur-bg' || filter.value.startsWith('change-bg:')))
                ) {
                    ctxOut.drawImage(videoInput, 0, 0, videoFilter.width, videoFilter.height);
                } else if (filter.value == 'blur-bg') {
                    ctxBg.clearRect(0, 0, videoFilter.width, videoFilter.height);
                    ctxBg.globalCompositeOperation = 'source-over';
                    applyBlurFilter(ctxBg, 2);
                    ctxBg.drawImage(canvasMask, 0, 0, videoFilter.width, videoFilter.height);
                    applyBlurFilter(ctxBg, false);
                    ctxBg.globalCompositeOperation = 'source-out';
                    ctxBg.drawImage(videoInput, 0, 0, videoFilter.width, videoFilter.height); // do not use canvasInput instead of video, otherwise it scales and takes more time.

                    ctxOut.filter = 'blur(10px)';
                    ctxOut.drawImage(videoInput, 0, 0, videoFilter.width, videoFilter.height);
                    ctxOut.filter = 'none';
                    ctxOut.drawImage(canvasBg, 0, 0);
                } else if (filter.value && filter.value.startsWith('change-bg:')) {
                    ctxBg.clearRect(0, 0, videoFilter.width, videoFilter.height);
                    ctxBg.globalCompositeOperation = 'source-over';
                    applyBlurFilter(ctxBg, 2);
                    ctxBg.drawImage(canvasMask, 0, 0, videoFilter.width, videoFilter.height);
                    applyBlurFilter(ctxBg, false);
                    ctxBg.globalCompositeOperation = 'source-out';
                    ctxBg.drawImage(videoInput, 0, 0, videoFilter.width, videoFilter.height); // do not use canvasInput instead of video, otherwise it scales and takes more time.

                    if (filter.background) {
                        if (!videoFilter.objectFit || videoFilter.objectFit == 'stretch') {
                            // previous code.
                            ctxOut.drawImage(filter.background, 0, 0, videoFilter.width, videoFilter.height);
                        } else {
                            // new code.
                            var background = filter.background;
                            var dx = 0,
                                dy = 0,
                                dw = videoFilter.width,
                                dh = videoFilter.height;
                            var sx = dx,
                                sy = dy,
                                sw = dw,
                                sh = dh;
                            if (background instanceof Image && background.naturalWidth && background.naturalHeight) {
                                sw = background.naturalWidth;
                                sh = background.naturalHeight;
                            } else if (background.videoWidth && background.videoHeight) {
                                sw = background.videoWidth;
                                sh = background.videoHeight;
                            }
                            var sr = sw / sh,
                                dr = dw / dh;
                            if (videoFilter.objectFit == 'cover') {
                                if (sr >= dr) {
                                    sx = sw / 2 - (sh * dr) / 2;
                                    sw = sh * dr;
                                } else {
                                    sy = sh / 2 - sw / (2 * dr);
                                    sh = sw / dr;
                                }
                            } else {
                                // contain
                                if (sr >= dr) {
                                    dy = dh / 2 - dw / (2 * sr);
                                    dh = dw / sr;
                                } else {
                                    dx = dw / 2 - (dh * sr) / 2;
                                    dw = dh * sr;
                                }
                            }
                            ctxOut.drawImage(
                                filter.background,
                                Math.round(sx),
                                Math.round(sy),
                                Math.round(sw),
                                Math.round(sh),
                                Math.round(dx),
                                Math.round(dy),
                                Math.round(dw),
                                Math.round(dh)
                            );
                        }
                    }
                    ctxOut.drawImage(canvasBg, 0, 0);
                }
            }
        }

        // apply default supplied blur value if model is original, or none if model is alt or null.
        // if extra attribute is present for blur, then use that irrespective of model or supplied value.
        function applyBlurFilter(ctx, value) {
            var blur = videoFilter.extra ? videoFilter.extra.blur : undefined;
            if (value === false) {
                if ((blur === undefined && videoFilter.model == 'orig') || blur !== undefined) {
                    ctx.filter = 'none';
                }
            } else {
                if (blur !== undefined) {
                    value = parseInt(blur) || 0;
                } else if (videoFilter.model != 'orig') {
                    value = 0;
                }
                if (value) {
                    ctx.filter = 'blur(' + value + 'px)';
                }
            }
        }

        function onStartVideoFilterComplete(identifier, error) {
            if (identifier) {
                var stream = previewVideoStream[identifier];
                if (stream) {
                    if (error) {
                        $rootScope.$broadcast('virtual-background-stream-error', {
                            error: error,
                            identifier: identifier
                        });
                    } else {
                        $rootScope.$broadcast('virtual-background-stream-started', {
                            stream: stream,
                            identifier: identifier
                        });
                    }
                }
            } else {
                //from main feed
                if (error) {
                    logger.error('onStartVideoFilterComplete', 'error', error);
                    $rootScope.$broadcast('stop-sfu-videopublish');
                    showAlert(localizationService.translate('SCREENSHARE.DIALOG.PROBLEM_ACCESSING_WEBCAM'));
                }
            }
        }

        function onStartVirtualBackgroundStream(data, getMediaConstraints) {
            previewVideoFilter[data.identifier] = data.filter;
            var stream = service.startVideoFilterStream(
                getMediaConstraints,
                undefined,
                data.identifier,
                service.onStartVideoFilterComplete
            );
            previewVideoStream[data.identifier] = stream;
        }

        function onStopVirtualBackgroundStream(data) {
            service.stopVideoFilterStream(data.identifier);
            delete previewVideoFilter[data.identifier];
        }

        function getConstraintDeviceId(id) {
            return helperService.isSafari() ? id : { exact: id };
        }

        function setIsVideoFiltersAvailable(value) {
            isVideoFiltersAvailable = value;
        }

        function getIsVideoFiltersAvailable() {
            return isVideoFiltersAvailable;
        }

        function getActiveFeedStream() {
            return activeFeedStream;
        }

        function setActiveFeedStream(stream) {
            activeFeedStream = stream;
        }

        function setVideoFilterConfig(value) {
            if (videoFilterConfigAllowedValues.indexOf(value) > -1) {
                videoFilterConfig = value;
            }
        }

        //Currently there is a lack of unit testing around this filter (as it realtes to config model)
        //so this function is here primarily for testing ATM
        function getVideoFilterConfig(value) {
            return videoFilterConfig;
        }
    }
]);
